var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"GQacVFXkpFJY7fvUUbdx5"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from "@sentry/react";

Sentry.init({
  dsn:
    "https://c67a5c69549d7fe46e44c1c9f41a9c92@o4507723380555776.ingest.de.sentry.io/4509156596580432",
  tracesSampleRate: 0.0
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
